import { useMutation, useQuery } from 'react-query'
import { TProduct } from 'types'
import { Entity } from 'utils/hooks'
import { useFloursService } from 'services/floursService'
import { ProductsModuleAdapter } from '../types/shared.types'

export const flourProductsAdapter: ProductsModuleAdapter = {
  moduleKey: 'flour',
  headerTitle: 'Flours Spec',
  addButtonText: 'Add Flour Spec',
  tableKey: 'flourProduct',

  labels: {
    nameColumn: 'Name',
    deleteConfirmTitle: 'Are you sure you want to remove this Flour product?',
    loadingText: 'Loading...',
  },

  toasts: {
    created: 'Flour product created',
    updated: 'Flour product updated',
    deleted: 'Flour product deleted successfully',
    deleteFailed: 'Flour product cannot be deleted',
    updateFailed: 'An error accured while updating Flour product',
  },
  invalidatQueryName: 'flour_spec_products_list',
  permissionEntity: Entity.PRODUCT_FLOUR,

  useDefaultAttributes() {
    const { getFlourAttributes } = useFloursService()
    const q = useQuery({
      queryKey: ['flour_attributes'],
      queryFn: () => getFlourAttributes(),
    })
    return { data: q.data }
  },

  useCategories() {
    const { getFlourCategoriesWithAttributes } = useFloursService()
    const q = useQuery({
      queryKey: ['flour_categories_with_attributes'],
      queryFn: () => getFlourCategoriesWithAttributes(),
    })
    return { data: q.data }
  },

  computeValidationRules(attrs) {
    return (attrs ?? []).reduce(
      (acc, a: any) => {
        acc[a.name] = {
          min: a?.min_value || 0,
          max: a?.max_value || 0,
          hardMax: a?.hard_max || 0,
          hardMin: a?.hard_min || 0,
          warnAbove: a?.warn_above || 0,
          warnBelow: a?.warn_below || 0,
        }
        return acc
      },
      {} as Record<string, any>
    )
  },

  useProducts({ currentPage, itemsPerPage }) {
    const { getFlourProducts } = useFloursService()
    const q = useQuery({
      queryKey: ['flour_spec_products_list', currentPage, itemsPerPage],
      queryFn: () => getFlourProducts({ currentPage, itemsPerPage }),
      retry: false,
    })
    // normalize to shared response shape
    return { data: q.data as any, isLoading: q.isLoading }
  },

  useCreate() {
    const { createFlourProduct } = useFloursService()
    const m = useMutation(createFlourProduct)
    return (p: TProduct) => m.mutateAsync(p as any)
  },

  useUpdate() {
    const { updateFlourProduct } = useFloursService()
    const m = useMutation(updateFlourProduct)
    return (p: TProduct) => m.mutateAsync(p as any)
  },

  useDelete() {
    const { deleteFlourProduct } = useFloursService()
    const m = useMutation(deleteFlourProduct)
    return (id: number) => m.mutateAsync(id)
  },
}
